
export interface PriceObject {
    cost: number;
    currency: string;
    installation: string;
    transferPrice: number;
    value: number;
    volume: number;
    weight: number;
}

export interface PriceMap {
    total: PriceObject;
    articles: Map<string, PriceObject>;
}

export interface VariantObject {
    variantno: string;
    path: string;
    filename: string;
}

export interface KompanConfiguration {
    PCuser: string;
    CountryCode: string;
    NavisionUser: string;
    Email: string;
    SourceSystemConnection: string;
    NavisionSystemName: string;
    PConPathConfigurations: string;
    PConPathVariants: string;
    DistributionRegion: string | null;
    BaseArticleNumber: string;
    VariantCode: string;
    UiLanguage: string;
    DataLanguage: string;
    NumberFormat: string;
    ProductNo: string;
    ReopenConfiguration: string;
    FileName: string;
    ProductType: string;

    WS_CalculatePrice: (data: string) => PriceObject;
    WS_GetNextVariantId: () => VariantObject;
    WS_CreateVariant: (
        productNo: string,
        variantNo: string,
        variantPath: string,
        variantFilename: string,
        price: number,
        description: string,
        finalArticleNumber: string | undefined,
        featureText: string
    ) => any;
    CloseWithoutVariant: () => void;
}

export abstract class KompanBase {
    public static get Configuration(): KompanConfiguration {
        if (KompanBase.openedByQuoteIt) {
            return window.opener.PConObj as KompanConfiguration;
        }
        return { DistributionRegion: 'kompan_ANY' } as KompanConfiguration;
    }

    public static getEAIWSUrl(): string {
        if ((window.location.host.indexOf('localhost') !== -1)) {
            return 'https://testpconbox.kompan.com';
        }
        const tProtocol: string = window.location.protocol;
        let tUrl: string = tProtocol + '//testpconbox.kompan.com';
        if (window.location.host.indexOf('kompan') !== -1) {
            tUrl = tProtocol + '//' + window.location.host;
        }

        return tUrl;
    }

    public static get openedByQuoteIt(): boolean {
        return (window.opener && (window.opener.PConObj || window.opener.PlannerObj));
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Kompan/KompanBase.ts